
import React from 'react';
import CashfreeDropInCheckout from './CashfreeDropInCheckout';
import { Button } from '@/components/ui/button';
import { getPlanById } from '@/config/pricingPlans';

interface EnhancedPurchasePlanButtonProps {
  planId: string;
  customerName?: string;
  customerEmail?: string;
  customerPhone?: string;
  variant?: 'default' | 'cta' | 'outline' | 'ghost' | 'link' | 'destructive' | 'secondary';
}

const EnhancedPurchasePlanButton: React.FC<EnhancedPurchasePlanButtonProps> = ({
  planId,
  customerName,
  customerEmail,
  customerPhone,
  variant = 'default'
}) => {
  const plan = getPlanById(planId);
  
  if (!customerName || !customerEmail) {
    return (
      <Button
        className="w-full"
        variant={variant === 'cta' ? 'default' : variant}
        disabled={true}
      >
        Please fill in required fields
      </Button>
    );
  }

  return (
    <CashfreeDropInCheckout
      amount={plan.monthlyAmount}
      productName={plan.title + ' Plan'}
      customerName={customerName}
      customerEmail={customerEmail}
      customerPhone={customerPhone}
      planId={planId}
      onSuccess={(data) => {
        console.log("Payment successful", data);
      }}
      onFailure={(error) => {
        console.log("Payment failed, error:", error);
      }}
    />
  );
};

export default EnhancedPurchasePlanButton;
